import React, { useRef, forwardRef, useImperativeHandle } from "react";
import { Toast } from "primereact/toast";

const ResultToast = forwardRef((props, ref) => {
  const toast = useRef(null);

  const show = (tipo, messageError, dettaglio) => {
    var icona = "";
    if (tipo == "error") {
      icona = "pi pi-times-circle";
    }
    if (tipo == "info") {
      icona = "pipi-info-circle";
    }
    if (tipo == "success") {
      icona = "pi pi-check-circle";
    }
    if (tipo == "warning") {
      icona = "pi pi-exclamation-triangle";
    }
    toast.current.show({
      severity: tipo,
      life: 3000,
      closable: false,
      content: (
        <div className="flex flex-column" style={{ flex: "1" }}>
          <div className="text-center">
            <i className={icona} style={{ fontSize: "3rem" }}></i>
            <h4>{messageError}</h4>
            <h5>{dettaglio}</h5>
          </div>
        </div>
      ),
    });
  };

  useImperativeHandle(ref, () => ({
    showToast: show,
  }));

  return (
    <div className="card flex justify-content-center">
      <Toast ref={toast} position="bottom-center" />
    </div>
  );
});

ResultToast.displayName = "ResultToast";
export default ResultToast;
